import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IInstantMessageChannelItem, InstantMessageChannelItem } from "./instantMessageChannelItem";
import { IInstantMessageListItem, InstantMessageListItem } from "./instantMessageListItem";

export interface IInstantMessageListItems extends ListItems<IInstantMessageListItem> {
    //Used in Mobile
    channel: IInstantMessageChannelItem;
    maxInstantMessageAttachmentSize: number;
}

export class InstantMessageListItems extends ListItems<InstantMessageListItem> implements IInstantMessageListItems {
    //Used in Mobile
    channel: InstantMessageChannelItem;
    maxInstantMessageAttachmentSize: number;

    constructor();
    constructor(obj: IInstantMessageListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray<InstantMessageListItem>(obj ? obj.items : null, InstantMessageListItem);
        //Used in Mobile
        this.channel = obj && obj.channel ? new InstantMessageChannelItem(obj.channel) : null;
        this.maxInstantMessageAttachmentSize = obj && obj.maxInstantMessageAttachmentSize || 0;
    }
}